var Slider = (function($) {

  var _s = {
    container: '.chm-block-slider',
    slides_container: '.slides-container',
    slide_container: '.slide-container',
    arrows_container: '.arrows-container',
    dots_container: '.dots-container'
  };

  var _init = function() {
    $(_s.container).each(function() {
      let arrows = $(this).find(_s.arrows_container);
      let dots = $(this).find(_s.dots_container);
    
      $(this).find(_s.slides_container).slick({
        autoplay:true,
        autoplaySpeed: 5000,
        infinite: true,
        initialSlide:0,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '0',
        speed:500,
        arrows: true,
        appendArrows: arrows,
        prevArrow:'<div class="slick-prev"><i class="fa-light fa-chevron-left"></i></div>',
        nextArrow:'<div class="slick-next"><i class="fa-light fa-chevron-right"></i></div>',
        dots: true,
        appendDots: dots,
        mobileFirst:true,
      });
    });

    _bindEvents();
  };

  var _bindEvents = function() {

  };

  return {
    init: _init
  };

})(jQuery);